import { useTranslation } from 'react-i18next';

export const getUserTypeDataTest = () => {
  const { t } = useTranslation();
  const userTypeMap = {
    REGULAR: t('LBLRegularContract'),
    LOCAL_ADMIN: t('LBLLocalAdminContract'),
    GLOBAL_ADMIN: t('LBLGlobalAdminContract'),
    AD_HOC: t('LBLAdHocContract'),
  };

  const userTypeAllList = Object.entries(userTypeMap).map(([key, label]) => ({
    key,
    label,
  }));

  const userTypeLabelToKeyMap = userTypeAllList.reduce(
    (acc, { key, label }) => {
      acc[label] = key;
      return acc;
    },
    {}
  );

  return { userTypeMap, userTypeAllList, userTypeLabelToKeyMap };
};

export const getUserTypeData = (t) => {
  const userTypeMap = {
    REGULAR: t('LBLRegularContract'),
    LOCAL_ADMIN: t('LBLLocalAdminContract'),
    GLOBAL_ADMIN: t('LBLGlobalAdminContract'),
    AD_HOC: t('LBLAdHocContract'),
  };

  const userTypeAllList = Object.entries(userTypeMap).map(([key, label]) => ({
    key,
    label,
  }));

  const userTypeLabelToKeyMap = userTypeAllList.reduce(
    (acc, { key, label }) => {
      acc[label] = key;
      return acc;
    },
    {}
  );

  return { userTypeMap, userTypeAllList, userTypeLabelToKeyMap };
};

export const getBillingCycleData = (t) => {
  const billingCycleMap = {
    IMMEDIATE: t('LBLBillingCycleImmediate'),
    MONTHLY: t('LBLBillingCycleMonthly'),
    QUARTERLY: t('LBLBillingCycleQuarterly'),
    SEMI_ANNUAL: t('LBLBillingCycleSemiAnnual'),
    ANNUAL: t('LBLBillingCycleAnnual'),
  };

  const billingCycleAllList = Object.entries(billingCycleMap).map(
    ([key, label]) => ({
      key,
      label,
    })
  );
  const billingCycleLabelToKeyMap = billingCycleAllList.reduce(
    (acc, { key, label }) => {
      acc[label] = key;
      return acc;
    },
    {}
  );
  return { billingCycleMap, billingCycleAllList, billingCycleLabelToKeyMap };
};
export const getPaymentMethodsData = (t) => {
  const paymentMethodsMap = {
    BANK_TRANSFER: t('rechnung'),
    STRIPE_SEPA: t('sepaStripemode'),
    SEPA: t('LBLsepamode'),
    STRIPE_CARD: t('cardStripeMode'),
    NO_PAYMENT_METHOD: 'NO_PAYMENT_METHOD',
  };
  const paymentMethodsAllList = Object.entries(paymentMethodsMap).map(
    ([key, label]) => ({
      key,
      label,
    })
  );
  const paymentMethodLabelToKeyMap = paymentMethodsAllList.reduce(
    (acc, { key, label }) => {
      acc[label] = key;
      return acc;
    },
    {}
  );
  return {
    paymentMethodsMap,
    paymentMethodsAllList,
    paymentMethodLabelToKeyMap,
  };
};

export const getBillStatusData = (t) => {
  const billingStatusesMap = {
    PAID: t('LBLBillPaid'),
    UNPAID: t('LBLBillUnpaid'),
    GENERATED: t('LBLBillGenerated'),
    SENT: t('LBLBillSent'),
    NOT_APPLICABLE: t('LBLBillNotApplicable'),
    DISPUTE_CREATED: t('LBLBillDisputeCreated'),
    DISPUTED: t('LBLBillDisputed'),
  };

  const billingStatusesAllList = Object.entries(billingStatusesMap).map(
    ([key, label]) => ({
      key,
      label,
    })
  );
  const billingStatusesLabelToKeyMap = billingStatusesAllList.reduce(
    (acc, { key, label }) => {
      acc[label] = key;
      return acc;
    },
    {}
  );



  return {
    billingStatusesMap,
    billingStatusesAllList,
    billingStatusesLabelToKeyMap,
  };
};
